'use client';

import { handleHeaderColorScheme } from '@lib/store/slices/ComponentsSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useScroll from '../hooks/useScroll';
import { useViewport } from '../hooks/useViewport';

const ScrollHelperTransTwo = () => {
  const dispatch = useDispatch();

  const { isMobile } = useViewport();

  const ScrollComponent = () => {
    const { scrollY } = useScroll();

    useEffect(() => {
      if (isMobile) {
        dispatch(handleHeaderColorScheme(''));
      } else {
        if (scrollY < 50) {
          dispatch(handleHeaderColorScheme('whiteOnTransparent'));
        } else {
          dispatch(handleHeaderColorScheme(''));
        }
      }
    }, [scrollY, isMobile, dispatch]);

    return null;
  };

  useEffect(() => {
    dispatch(handleHeaderColorScheme('whiteOnTransparent'));
    return function () {
      dispatch(handleHeaderColorScheme(''));
    };
  }, []);

  return typeof window !== 'undefined' ? <ScrollComponent /> : null;
};

export default ScrollHelperTransTwo;
